import { makeStyles } from 'tss-react/mui';

const calcHeight = ({ theme }: { theme?: 'vk' | 'widget' }) => {
  switch (theme) {
    case 'vk':
      return 'calc(100vh - 37px)';
    case 'widget':
      return 'calc(100vh - 64px)';
    default:
      return '100vh';
  }
};

export const useStyles = makeStyles<{
  sidebarIconWidth: number;
  theme?: 'vk' | 'widget';
}>()(({ tokens, transitions }, { sidebarIconWidth, theme }) => ({
  sidebar: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: 64,
    minWidth: 64,
    height: calcHeight({ theme }),
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: tokens.colors.bg.light.primary,
    borderRight: `1px solid ${tokens.colors.stroke.primary}`,
    padding: tokens.spacing['12'],
    transition: `all ${transitions.easing.easeInOut} 0.5s`,
    willChange: 'width',

    '&::-webkit-scrollbar': {
      width: '0 !important',
    },
  },

  sidebarOpened: {
    width: 280,
    minWidth: 280,
  },

  sidebarMenu: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingTop: tokens.spacing['40'],
    paddingBottom: tokens.spacing['32'],
    scrollbarWidth: 'none',

    '&::-webkit-scrollbar': {
      width: '0 !important',
    },
  },

  overlayTop: {
    position: 'absolute',
    top: 50,
    left: 0,
    height: 36,
    width: '100%',
    background: `linear-gradient(180deg, ${tokens.colors.bg.light.primary} 50%, rgba(0, 0, 0, 0) 100%)`,
    zIndex: 1,
  },

  overlayBottom: {
    position: 'absolute',
    bottom: 31,
    left: 0,
    height: 36,
    width: '100%',
    background: `linear-gradient(0deg, ${tokens.colors.bg.light.primary} 50%, rgba(0, 0, 0, 0) 100%)`,
  },

  sidebarLogo: {
    display: 'flex',
    alignItems: 'center',
    width: 'auto',
    minHeight: 40,
    height: 40,
    overflow: 'hidden',
    transition: `width ${transitions.easing.easeInOut} 0.5s`,
    willChange: 'width',
  },

  sideBarExpandButton: {
    display: 'flex',
    alignItems: 'center',
    width: `${sidebarIconWidth}px`,
    minWidth: `${sidebarIconWidth}px`,
    height: 40,
    minHeight: 40,
    marginTop: 'auto',
    gap: tokens.spacing['16'],
    padding: tokens.spacing['8'],
    borderRadius: tokens.radius.s,
    background: tokens.colors.bg.light.primary,
    overflow: 'hidden',
    cursor: 'pointer',
    zIndex: 1,

    '&:hover': {
      backgroundColor: tokens.colors.bg.greyscale.secondary,
    },
  },
}));
